import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { DpTableComponent } from '../../../../common-component/dp-table/dp-table.component';
import { PrivilegeCellComponent } from '../../../../table-cell/privilege-cell.component';
import { PermissionsButtonComponent } from '../../../../table-cell/manage-userPermission-button-cell.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonUtilService } from '../../../../services/common-util/common-util.service';
import { ToastrService } from 'ngx-toastr';
import { ManageUserService } from '../../../../services/raintree/Transmission/manage-user.service';
import { PermissionList } from '../../../../services/raintree/interfaces/manage-user';
import { forkJoin, map } from 'rxjs';
import { response } from 'express';
import { StateDistrictDialogComponent } from '../state-district-dialog/state-district-dialog.component';
import { PermissionViewerComponent } from "../permission-viewer/permission-viewer.component";
import { StateDistrictPopupComponent } from '../../../../manage-user/state-district-popup/state-district-popup.component';
import { SaveConfirmManageUserComponent } from '../save-confirm-manage-user/save-confirm-manage-user.component';
import { AppConfigService } from '../../../../services/config/app-config.service';
import { SatesListService } from '../../../../services/raintree/Transmission/sates-list.service';
import { DistrictListService } from '../../../../services/raintree/Transmission/district-list.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

interface Permission {
  id: number;
  name: string;
  status: string;
  viewHId: number;
}

interface Permission2 {
  id: number;
  name: string;
  status?: boolean;
  vhp_id: number;
  is_default: number;
  is_optional: number;
}
interface mergedPermission {
  id: number;
  name: string;
  states: { state_name: string; districts: string[] }[];
  states_perm?: { state_name: string; districts: string[] }[];
  role_id?: any;
}

interface Subview {
  key: number;
  permission: Permission[];
  viewName: string;
  labelName: string;
  country: string;
  state: string;
  district: string;
  level: number;
  role_id: number;
  status: string;
  subview: Subview[];
}

interface Subview2 {
  dwh_id: number;
  dvp_permission_name: Permission2[];
  view_name: string;
  view_label: string;
  dwh_parent_view_id: number;
  drm_id: number;
}

interface MergedSubview {
  key: number;
  permission: mergedPermission[];
  viewName: string;
  labelName: string;
  role_id: number;
  subview: MergedSubview[];
}

interface newPerm {
  country: string;
  state: string;
  district: string;
  roleId: number;
  key: number;
  permissionId: number;
  viewHId: number | null;
  status: string;
  isNew: boolean;
}
interface newPerm2 {
  country: string;
  states: {
    state_name: string;
    districts: string[];
  }[];
  roleId: number;
  key: number;
  permissionId: number;
  viewHId: number;
  status: string;
  // isNew:boolean;
}
interface RoleIdMap {
  level: string,
  role_id: number
}

const permissionLevels: { [key: string]: string[] } = {
  "can_manage_super_user": ["FIELD LEVEL", "DISTRICT LEVEL", "STATE LEVEL", "SPECIAL LEVEL"],
  "can_manage_state_admin": ["FIELD LEVEL", "DISTRICT LEVEL", "STATE LEVEL"],
  "can_manage_district_admin": ["FIELD LEVEL", "DISTRICT LEVEL"],
  "can_manage_field_worker": ["FIELD LEVEL"],
};

const levelRoleMap: { [key: string]: number } = {
  "SPECIAL LEVEL": 2,
  "STATE LEVEL": 3,
  "DISTRICT LEVEL": 4,
  "FIELD LEVEL": 5
};
@Component({
  selector: 'app-manage-userPermission-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    LoaderComponent,
    ReactiveFormsModule,
    PermissionViewerComponent,
    FormsModule,
    InfiniteScrollModule,
    DpTableComponent,
  ],
  templateUrl: './manage-userPermission-dialog.component.html',
  styleUrls: [
    './manage-userPermission-dialog.component.scss',
    '../../../../../styles/_dropdown.scss',
  ],
})

export class ManageUserPermissionDialogComponent implements OnInit {
  isMobileView: boolean = false;
  statusActive: boolean = false;
  userForm!: FormGroup;
  userPermissionList: Subview[] = [];
  processedUserPermissionList: newPerm2[] = [];
  processedInactivePermissionList: newPerm2[] = [];
  showPermissions: MergedSubview[] = [];
  isLoading: boolean = false;
  userData: any;
  changedPermissions: newPerm[] = [];
  managerPermission: Subview2[] = [];
  showLabel: { [key: number]: string } = {};
  parentMap: { [key: number]: number } = {};
  childMap: { [key: number]: number[] } = {};
  viewHids: any[] = [];
  user_role: string = '';
  roles!: RoleIdMap[];
  roleDetails: any = [];
  rolePermissionList: any[] = [];
  selectRole = new FormControl([Validators.required]);
  role_id!: number;
  permissionArray: any = [];
  allStates: any[] = [];
  allDistrict: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
    private _manageUserService: ManageUserService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ManageUserPermissionDialogComponent>,
    private appConfigService: AppConfigService,
    private stateTransmissionService: SatesListService,
    private districtListService: DistrictListService,
  ) { }
  // manageUserPermALL :any = []
  // manageUserPermWithLoc: any = []
  ngOnInit(): void {
    this.isLoading = true;
    this.isMobileView = this.isMobile.isMobileDevice();
    if (this.data.userDetails.status.toLowerCase() === 'active') {
      this.statusActive = true;
    }
    this.userForm = new FormGroup({
      userStatus: new FormControl(this.statusActive),
    });
    if (!this.data.isSuperUser) {
      this.userForm.get('userPrivilege')?.disable();
      // this.userForm.get('userStatus')?.disable();
    }
    this.userData = this.data.userDetails
    this.roleDetails = this.data.roleDetails
    this.rolePermissionList = this.data.rolePermissionList
    this.isLoading = false;
    // this.loaduserPermissionList();
  }
  closeDialog() {
    this.dialogRef.close(true);
  }
  flattenPermissions(): newPerm2[] {
    const flatPermissions: newPerm2[] = [];
    const flatInactivePermissions: newPerm2[] = [];
    const viewHids: any[] = [];
    const stateList = this.data.states;
    const districtList = this.data.districts;
    function processSubview(subview: Subview) {
      if (stateList.includes(subview.state) && districtList[subview.state]?.includes(subview.district)) {
        subview.permission.forEach(perm => {
          if (perm.status === 'Active') {
            const existingEntry = flatPermissions.find(entry =>
              entry.country === subview.country &&
              entry.roleId === subview.role_id &&
              entry.key === subview.key &&
              entry.permissionId === perm.id
            );
            if (existingEntry) {
              const stateEntry = existingEntry.states.find(state => state.state_name === subview.state);
              if (stateEntry) {
                if (!stateEntry.districts.includes(subview.district)) {
                  stateEntry.districts.push(subview.district);
                  viewHids.push({
                    key: subview.key,
                    id: perm.id,
                    state: subview.state,
                    district: subview.district,
                    viewHid: perm.viewHId,
                  });
                }
              } else {
                existingEntry.states.push({
                  state_name: subview.state,
                  districts: [subview.district]
                });
                viewHids.push({
                  key: subview.key,
                  id: perm.id,
                  state: subview.state,
                  district: subview.district,
                  viewHid: perm.viewHId,
                });
              }
            } else {
              flatPermissions.push({
                country: subview.country,
                states: [{
                  state_name: subview.state,
                  districts: [subview.district]
                }],
                roleId: subview.role_id,
                key: subview.key,
                permissionId: perm.id,
                viewHId: perm.viewHId,
                status: perm.status
              });
              viewHids.push({
                key: subview.key,
                id: perm.id,
                state: subview.state,
                district: subview.district,
                viewHid: perm.viewHId,
              });
            }
          }
          else if (perm.status == 'In-Active') {
            const existingEntry = flatInactivePermissions.find(entry =>
              entry.country === subview.country &&
              entry.roleId === subview.role_id &&
              entry.key === subview.key &&
              entry.permissionId === perm.id
            );
            if (existingEntry) {
              const stateEntry = existingEntry.states.find(state => state.state_name === subview.state);
              if (stateEntry) {
                if (!stateEntry.districts.includes(subview.district)) {
                  stateEntry.districts.push(subview.district);
                  viewHids.push({
                    key: subview.key,
                    id: perm.id,
                    state: subview.state,
                    district: subview.district,
                    viewHid: perm.viewHId,
                  });
                }
              } else {
                existingEntry.states.push({
                  state_name: subview.state,
                  districts: [subview.district]
                });
                viewHids.push({
                  key: subview.key,
                  id: perm.id,
                  state: subview.state,
                  district: subview.district,
                  viewHid: perm.viewHId,
                });
              }
            } else {
              flatInactivePermissions.push({
                country: subview.country,
                states: [{
                  state_name: subview.state,
                  districts: [subview.district]
                }],
                roleId: subview.role_id,
                key: subview.key,
                permissionId: perm.id,
                viewHId: perm.viewHId,
                status: perm.status
              });
              viewHids.push({
                key: subview.key,
                id: perm.id,
                state: subview.state,
                district: subview.district,
                viewHid: perm.viewHId,
              });
            }
          }
        });
        subview.subview.forEach(subSubview => processSubview(subSubview));
      }
    }
    this.userPermissionList.forEach(view => processSubview(view));
    this.processedInactivePermissionList = flatInactivePermissions;
    this.viewHids = viewHids;
    return flatPermissions;
  }
  processPermission(permissions: Permission2[], view_key: number): mergedPermission[] {
    const mergePerm: mergedPermission[] = permissions.map((perm) => {
      const userSamePerm = this.processedUserPermissionList.find(perm_ => perm_.key === view_key && perm_.permissionId === perm.id);
      if (userSamePerm && userSamePerm.status == 'Active') {
        return {
          id: perm.id,
          name: perm.name,
          states: userSamePerm.states,
        };
      }
      else {
        return {
          id: perm.id,
          name: perm.name,
          states: [],
        };
      }
    });
    return mergePerm;
  }
  mergeSubView(data: Subview2[]): MergedSubview[] {
    // const parentMap: {[key:number]:number}={};
    const view_label_map: { [key: number]: string } = {};
    const finalView: MergedSubview[] = data.map((view) => {
      this.parentMap[view.dwh_id] = view.dwh_parent_view_id;
      if (view.dwh_parent_view_id !== 0) {
        if (!this.childMap[view.dwh_parent_view_id]) this.childMap[view.dwh_parent_view_id] = [];
        if (!this.childMap[view.dwh_parent_view_id].includes(view.dwh_id)) this.childMap[view.dwh_parent_view_id].push(view.dwh_id);
      }
      view_label_map[view.dwh_id] = view.view_label;
      return {
        key: view.dwh_id,
        permission: this.processPermission(view.dvp_permission_name, view.dwh_id),
        viewName: view.view_name,
        labelName: view.view_label,
        role_id: view.drm_id,
        subview: [],
      }
    });
    const showLabelMap: { [key: number]: string } = {};
    data.forEach((view) => {
      let labelName: string = view.view_label;
      //   let parent: number=view.dwh_parent_view_id;
      //   if(Object.keys(view_label_map).includes(String(parent))){
      //     while(parent!=0){
      //       let parent_label= view_label_map[parent];
      //       parent=this.parentMap[parent];
      //       labelName=parent_label+" > "+labelName;
      //       }
      //     }
      showLabelMap[view.dwh_id] = labelName;
    });
    this.showLabel = showLabelMap;
    return finalView;
    // const viewMap: { [key: string]: MergedSubview } = {};
    // data.forEach((item) => {
    //   const key = item.viewName;
    //   if (!viewMap[key]) {
    //     const sameViewData= data.filter((view:Subview2)=> view.key===item.key);
    //     let permissionUnion: mergedPermission[]=[];
    //     let subviewUnion: Subview2[]=[];
    //     sameViewData.forEach((view:Subview2)=>{
    //       permissionUnion= this.mergePermissions(view.permission,permissionUnion,item.key);
    //       subviewUnion=subviewUnion.concat(view.subview);
    //     })
    //     viewMap[key] = {
    //       key: item.key,
    //       permission: permissionUnion,
    //       viewName: item.viewName,
    //       labelName: item.labelName,
    //       role_id: item.role_id,
    //       subview: this.mergeSubView(subviewUnion),
    //     };
    //   }
    // });
    // return Object.values(viewMap);
  }
  onStatusToggle(event: any): void {
    this.isLoading = true;
    const bodyObj = {
      verify: this.userForm.get('userStatus')?.value,
    }
    this._manageUserService.updatePermissions(this.data.userDetails.id, bodyObj).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.userData.status === 'Active' ? this.userData.status = 'Inactive' : this.userData.status = 'Active';
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      }
    });
  }
  // onStateChange() {
  // }
  // handlePermissionChange(view: MergedSubview,permission: mergedPermission, newStatus: string) {
  //   const index = this.changedPermissions.findIndex(p => p.permissionId === permission.id);
  //   if (index === -1) {
  //     if (permission.status !== newStatus)this.changedPermissions.push(
  //       { country: "INDIA",
  //         state: this.selectedState,
  //         district: this.selectedDistrict,
  //         roleId: view.role_id,
  //         key: view.key,
  //         permissionId: permission.id,
  //         viewHId: permission.viewHId,
  //         status: newStatus,
  //         isNew: false,
  //       });
  //   } else {
  //     if(permission.status !== newStatus)
  //     this.changedPermissions[index].status = newStatus;
  //     else this.changedPermissions.splice(index, 1);
  //   }
  //   permission.status = newStatus;
  // }
  // addNewPerm(newPermObject: newPerm){
  //   let existingChangedPerm= this.changedPermissions.find((perm)=>
  //     perm.country===newPermObject.country &&
  //     perm.state === newPermObject.state &&
  //     perm.district === newPermObject.district &&
  //     perm.roleId=== newPermObject.roleId &&
  //     perm.key=== newPermObject.key &&
  //     perm.permissionId === newPermObject.permissionId
  //   );
  //   if(existingChangedPerm){
  //     existingChangedPerm=newPermObject;
  //   }
  //   else{
  //     this.changedPermissions.push(newPermObject);
  //   }
  // }
  getViewHid(key: number, id: number, state: string, district: string): number | null {
    const HID = this.viewHids.find((hid: any) =>
      hid.state === state && hid.district === district && hid.key === key && hid.id === id
    );
    if (HID) {
      return HID.viewHid;
    } else {
      return null;
    }
  }
  addParentPermission(newPermObj: newPerm) {
    let par = this.parentMap[newPermObj.key];
    while (par != 0) {
      const sameParentView = this.showPermissions.find((view) => view.key === par);
      if (sameParentView) {
        const sameParentPerm = sameParentView.permission.find((perm) => perm.id === newPermObj.permissionId);
        if (sameParentPerm) {
          const ActiveSamePermission = this.processedUserPermissionList.find((perm) => perm.key === par && perm.permissionId === newPermObj.permissionId);
          if (ActiveSamePermission && ActiveSamePermission.states.find((st) => st.state_name === newPermObj.state)?.districts.includes(newPermObj.district)) {
          }
          else {
            const newPermObject: newPerm = {
              country: newPermObj.country,
              state: newPermObj.state,
              district: newPermObj.district,
              roleId: sameParentView.role_id,
              key: par,
              permissionId: newPermObj.permissionId,
              viewHId: this.getViewHid(par, newPermObj.permissionId, newPermObj.state, newPermObj.district),
              status: newPermObj.status,
              isNew: newPermObj.isNew,
            };
            this.changedPermissions.push(newPermObject);
          }
        }
      }
      par = this.parentMap[par];
    }
  }
  removeChildPermission(newPermObj: newPerm, parent: number) {
    this.childMap[parent]?.forEach((child) => {
      const sameChildView = this.showPermissions.find((view) => view.key === child);
      if (sameChildView) {
        const sameChildPerm = sameChildView.permission.find((perm) => perm.id === newPermObj.permissionId);
        if (sameChildPerm) {
          const ActiveSamePermission = this.processedUserPermissionList.find((perm) => perm.key === child && perm.permissionId === newPermObj.permissionId);
          if (ActiveSamePermission && ActiveSamePermission.states.find((st) => st.state_name === newPermObj.state)?.districts.includes(newPermObj.district)) {
            const newPermObject: newPerm = {
              country: newPermObj.country,
              state: newPermObj.state,
              district: newPermObj.district,
              roleId: sameChildView.role_id,
              key: child,
              permissionId: newPermObj.permissionId,
              viewHId: this.getViewHid(child, newPermObj.permissionId, newPermObj.state, newPermObj.district),
              status: newPermObj.status,
              isNew: newPermObj.isNew,
            };
            this.changedPermissions.push(newPermObject);
          }
        }
      }
      if (this.childMap[child]) this.removeChildPermission(newPermObj, child);
    });
  }
  handleNewStateDistrict(view: MergedSubview, permission: mergedPermission, districtList: any, isAdded: boolean) {
    const ActiveSamePermission = this.processedUserPermissionList.find((perm) => perm.key === view.key && perm.permissionId === permission.id);
    const InactiveSamePermission = this.processedInactivePermissionList.find((perm) => perm.key === view.key && perm.permissionId === permission.id);
    this.changedPermissions = this.changedPermissions.filter(
      (perm: newPerm) => !(perm.permissionId === permission.id && perm.key === view.key)
    );
    if (!isAdded) {
      const newPermObject: newPerm = {
        country: 'INDIA',
        state: districtList.state,
        district: districtList.district,
        roleId: view.role_id,
        key: view.key,
        permissionId: permission.id,
        viewHId: this.getViewHid(view.key, permission.id, districtList.state, districtList.district),
        status: 'In-Active',
        isNew: false,
      };
      this.changedPermissions.push(newPermObject);
      // this.removeChildPermission(newPermObject,newPermObject.key);
    }
    else {
      const isNew = !(InactiveSamePermission?.states.find(
        (st: any) => st.state_name === districtList.state)?.districts.includes(districtList.district));
      const newPermObject: newPerm = {
        country: 'INDIA',
        state: districtList.state,
        district: districtList.district,
        roleId: view.role_id,
        key: view.key,
        permissionId: permission.id,
        viewHId: this.getViewHid(view.key, permission.id, districtList.state, districtList.district),
        status: 'Active',
        isNew: isNew,
      };
      this.changedPermissions.push(newPermObject);
      // this.addParentPermission(newPermObject);
    }
    this.saveChanges();
  }
  saveChanges() {
    let test: any = this.changedPermissions[0].state
    this.changedPermissions[0].state = test
    if (this.changedPermissions.length > 0) {
      this.isLoading = true;
      const bodyObj = {
        permissions: this.changedPermissions
      }
      this._manageUserService.updatePermissions(this.data.userDetails.id, bodyObj).subscribe({
        next: (response) => {
          this.changedPermissions = [];
        },
        error: (error) => {
          this.isLoading = false;
          this.changedPermissions = [];
          this.toaster.error(error);
        }
      });
    }
  }
  onToggleOffPermission(view: MergedSubview, permission: mergedPermission) {
    this.changedPermissions = this.changedPermissions.filter(
      (perm: newPerm) => !(perm.permissionId === permission.id && perm.key === view.key)
    );
    const ActiveSamePermission = this.processedUserPermissionList.find((perm) => perm.key === view.key && perm.permissionId === permission.id);
    if (ActiveSamePermission) {
      ActiveSamePermission.states.forEach((state) => {
        state.districts.forEach((district) => {
          const newPermObject: newPerm = {
            country: 'INDIA',
            state: state.state_name,
            district: district,
            roleId: view.role_id,
            key: view.key,
            permissionId: permission.id,
            viewHId: this.getViewHid(view.key, permission.id, state.state_name, district),
            status: 'In-Active',
            isNew: false,
          };
          this.changedPermissions.push(newPermObject);
          this.removeChildPermission(newPermObject, newPermObject.key);
        });
      });
    }
    this.saveChanges();
  }
  onTogglePermissionNew(rowData: any) {
    this.isLoading = true;
    const bodyObj = {
      active: rowData.dupd_status == 'In-Active',
      state: this.roleDetails.state == 'ALL' ? null : this.roleDetails.state,
      district: this.roleDetails.district == 'ALL' ? null : this.roleDetails.district,
    }
    this._manageUserService.updatePermissionsNew(rowData.dupd_id, bodyObj).subscribe({
      next: (response) => {
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      }
    });
  }
};